import { createSlice } from "@reduxjs/toolkit";
import {
  clearStoredAuthSession,
  getStoredAuthSession,
  hasAuthTokens,
  normalizeAuthSession,
  persistAuthSession,
} from "./authSession";

export const loadAuthState = () => {
  try {
    const storedSession = getStoredAuthSession();

    if (storedSession && hasAuthTokens(storedSession)) {
      return {
        user: storedSession,
        isAuthenticated: true,
        loading: false,
        error: null,
      };
    }

    return {
      user: null,
      isAuthenticated: false,
      loading: false,
      error: null,
    };
  } catch {
    return {
      user: null,
      isAuthenticated: false,
      loading: false,
      error: null,
    };
  }
};

const initialState = loadAuthState();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const normalizedSession = persistAuthSession(action.payload);

      state.isAuthenticated = hasAuthTokens(normalizedSession);
      state.user = normalizedSession;
      state.loading = false;
      state.error = null;
    },

    logoutSuccess: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.loading = false;
      state.error = null;
      clearStoredAuthSession();
    },

    refreshTokenSuccess: (state, action) => {
      if (state.user) {
        const nextSession = normalizeAuthSession({
          ...state.user,
          accessToken: action.payload.accessToken,
          token: action.payload.accessToken,
          refreshToken:
            action.payload.refreshToken || state.user.refreshToken,
        });

        state.user = persistAuthSession(nextSession);
        state.isAuthenticated = hasAuthTokens(state.user);
      }
    },

    createUserRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    createUserSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },

    createUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loginSuccess,
  logoutSuccess,
  refreshTokenSuccess,
  createUserRequest,
  createUserSuccess,
  createUserFailure,
} = authSlice.actions;

export default authSlice.reducer;
